import SafetyCertificationItem from './SafetyCertificationItem';
export default SafetyCertificationItem;
